import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  flexWrap: 'wrap',
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(6),
  paddingBottom: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    padding: 0,
  },
}));

export const ChipContainer = styled('div')(({ theme, width }) => ({
  display: 'flex',
  alignItems: 'center',
  width: `${width}px`,
  overflow: 'hidden',
  transition: 'width 0.4s ease',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
    padding: theme.spacing(0),
  },
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
  },
}));

export const Link = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    paddingBottom: theme.spacing(2),
  },
}));
